"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$ = exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$outboundSchema = exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$inboundSchema = exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$ = exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$outboundSchema = exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$inboundSchema = exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$ = exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$outboundSchema = exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$inboundSchema = void 0;
exports.postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurityToJSON = postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurityToJSON;
exports.postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurityFromJSON = postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurityFromJSON;
exports.postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsPropertyToJSON = postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsPropertyToJSON;
exports.postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsPropertyFromJSON = postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsPropertyFromJSON;
exports.postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequestToJSON = postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequestToJSON;
exports.postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequestFromJSON = postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const shared = __importStar(require("../shared/index.js"));
/** @internal */
exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$;
(function (PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$) {
    /** @deprecated use `PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$inboundSchema` instead. */
    PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$.inboundSchema = exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$inboundSchema;
    /** @deprecated use `PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$outboundSchema` instead. */
    PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$.outboundSchema = exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$outboundSchema;
})(PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$ || (exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$ = PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$ = {}));
function postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurityToJSON(postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity) {
    return JSON.stringify(exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$outboundSchema
        .parse(postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity));
}
function postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostSecurity' from JSON`);
}
/** @internal */
exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$inboundSchema = z.union([
    shared.MultiplePropertyUserFields$inboundSchema,
    shared.PropertyUserFields$inboundSchema,
]);
/** @internal */
exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$outboundSchema = z.union([
    shared.MultiplePropertyUserFields$outboundSchema,
    shared.PropertyUserFields$outboundSchema,
]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$;
(function (PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$) {
    /** @deprecated use `PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$inboundSchema` instead. */
    PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$.inboundSchema = exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$inboundSchema;
    /** @deprecated use `PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$outboundSchema` instead. */
    PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$.outboundSchema = exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$outboundSchema;
})(PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$ || (exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$ = PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$ = {}));
function postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsPropertyToJSON(postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty) {
    return JSON.stringify(exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$outboundSchema
        .parse(postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty));
}
function postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsPropertyFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostQueryParamFieldsProperty' from JSON`);
}
/** @internal */
exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$inboundSchema = z.object({
    AddressMatchPostRequest: shared.AddressMatchPostRequest$inboundSchema,
    "fields[property]": z.array(z.union([
        shared.MultiplePropertyUserFields$inboundSchema,
        shared.PropertyUserFields$inboundSchema,
    ])),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "AddressMatchPostRequest": "addressMatchPostRequest",
        "fields[property]": "fieldsProperty",
    });
});
/** @internal */
exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$outboundSchema = z.object({
    addressMatchPostRequest: shared.AddressMatchPostRequest$outboundSchema,
    fieldsProperty: z.array(z.union([
        shared.MultiplePropertyUserFields$outboundSchema,
        shared.PropertyUserFields$outboundSchema,
    ])),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        addressMatchPostRequest: "AddressMatchPostRequest",
        fieldsProperty: "fields[property]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$;
(function (PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$) {
    /** @deprecated use `PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$inboundSchema` instead. */
    PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$.inboundSchema = exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$inboundSchema;
    /** @deprecated use `PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$outboundSchema` instead. */
    PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$.outboundSchema = exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$outboundSchema;
})(PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$ || (exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$ = PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$ = {}));
function postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequestToJSON(postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest) {
    return JSON.stringify(exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$outboundSchema
        .parse(postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest));
}
function postAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'PostAddressMatchV2LlmPropertiesAddressMatchV2LlmPostRequest' from JSON`);
}
//# sourceMappingURL=postaddressmatchv2llmpropertiesaddressmatchv2llmpost.js.map